import { ModalManager } from './modal-manager';

export class ModalService {
  constructor(public readonly manager: ModalManager) {}

  show(data: { name: string; props?: Record<string, any> }) {
    return this.manager.show(data);
  }

  close(nameOrId: string, result?: any) {
    this.manager.close(nameOrId, result);
  }

  closeTop(result?: any) {
    this.manager.closeTop(result);
  }

  async confirm(props: {
    severity?: 'alert' | 'warning' | 'info';
    header?: string;
    message: string;
    btnOk?: string;
    btnCancel?: string;
    default?: 'ok' | 'cancel';
  }) {
    const res = await this.manager.show({ name: 'ConfirmDialog', props });
    return !!res?.value;
  }

  error(options: {
    error?: any;
    title?: string;
    message?: string | string[];
    details?: string;
  }) {
    let message = options.message;
    let details = options.details;

    if (!message) {
      const exception = options.error;
      if (exception instanceof Error) {
        message = exception.message;
        if (!details && (exception as any).response?.data) {
          const respData = (exception as any).response.data;
          if (typeof respData === 'string') {
            details = respData;
          } else if (respData.message || respData.error) {
            details = String(respData.message || respData.error);
          }
        }
      } else if (typeof exception === 'string') {
        message = exception;
      } else if (typeof exception === 'boolean' || exception == null) {
        message = 'An unknown error occurred.';
      } else if (typeof exception === 'object') {
        message = exception.message || exception.error || String(exception);
      } else {
        message = String(exception);
      }
    }

    return this.manager.show({
      name: 'MessageBox',
      props: {
        type: 'error',
        header: options.title || 'Error',
        message,
        details,
      },
    });
  }
}
